import { BimClashRule } from 'Data/interfaces/BimViewer/IBimViewerPort';

/** Atalho de regra. O nome vem do i18n (`clash.rules.<id>`). */
export interface IClashPreset {
  id: string;
  a?: string;
  b?: string;
}

export const ALL_RULE_ID = 'all';
export const CUSTOM_RULE_ID = 'custom';

/**
 * Os mesmos pares do `CLASH_RULE_PRESETS` do `@ifc-lite/clash` (o que o demo
 * deles oferece), mais o "todos × todos", que é o padrão.
 */
export const CLASH_PRESETS: IClashPreset[] = [
  { id: ALL_RULE_ID },
  { id: 'plumbingStructure', a: 'IfcPipe*|IfcPump|IfcValve*|IfcTank', b: 'IfcBeam|IfcColumn|IfcSlab|IfcFooting' },
  { id: 'hvacStructure', a: 'IfcDuct*|IfcAirTerminal*|IfcUnitaryEquipment', b: 'IfcBeam|IfcColumn|IfcSlab' },
  { id: 'hvacArchitecture', a: 'IfcDuct*|IfcAirTerminal*', b: 'IfcWall|IfcSlab|IfcRoof' },
  { id: 'plumbingArchitecture', a: 'IfcPipe*|IfcPump|IfcValve*', b: 'IfcWall|IfcSlab|IfcRoof' },
  { id: 'hvacPlumbing', a: 'IfcDuct*', b: 'IfcPipe*' },
  { id: 'fireStructure', a: 'IfcFireSuppressionTerminal|IfcPipe*', b: 'IfcBeam|IfcColumn|IfcSlab' },
  { id: 'electricalMep', a: 'IfcCableSegment|IfcCableFitting|IfcCableCarrierSegment', b: 'IfcPipe*|IfcDuct*' }
];

export interface IClashCustomRule {
  typesA: string[];
  typesB: string[];
}

/** Lado sem tipo escolhido = todos os tipos. */
const selectorOf = (types: string[]): string => (types.length > 0 ? types.join('|') : '*');

/**
 * Regras ativas → regras do motor. Um par achado por duas regras fica com a
 * primeira, então as específicas vão antes e o "todos" por último: o conflito
 * tubo × viga aparece como "Hidráulica × Estrutura", não como "Todos".
 */
export const buildClashRules = (
  enabled: Set<string>,
  custom: IClashCustomRule,
  nameOf: (id: string) => string
): BimClashRule[] => {
  const rules: BimClashRule[] = CLASH_PRESETS
    .filter((preset) => preset.id !== ALL_RULE_ID && enabled.has(preset.id))
    .map((preset) => ({ id: preset.id, name: nameOf(preset.id), a: preset.a, b: preset.b }));

  const hasCustomTypes = custom.typesA.length > 0 || custom.typesB.length > 0;
  if (enabled.has(CUSTOM_RULE_ID) && hasCustomTypes) {
    rules.push({
      id: CUSTOM_RULE_ID,
      name: nameOf(CUSTOM_RULE_ID),
      a: selectorOf(custom.typesA),
      b: selectorOf(custom.typesB)
    });
  }
  if (enabled.has(ALL_RULE_ID)) {
    rules.push({ id: ALL_RULE_ID, name: nameOf(ALL_RULE_ID) });
  }
  return rules;
};
